export default {
    alert_types_title: "Alert Types",
    alert_types_add: "Add",
    alert_types_id: "Id",
    alert_types_name: "Name",
    alert_types_code: "Code",
    alert_types_created_on: "Created On",
    alert_types_parent_id: "Parent Id",
}